import _objectSpread from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/logo-EN.svg';
import _imports_1 from '@/assets/image/modelCode.svg';
import _imports_2 from '@/assets/image/sn.svg';
import _imports_3 from '@/assets/image/ok.svg';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-04ab7f34"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "activation-content"
};
var _hoisted_2 = {
  key: 0,
  class: "activation-header-logo"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_4 = [_hoisted_3];
var _hoisted_5 = {
  class: "activation-header-product"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});
var _hoisted_8 = {
  class: "activation-header-product-num"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1);
});
var _hoisted_10 = {
  class: "activation-header-product-num"
};
var _hoisted_11 = {
  class: "activation-country"
};
var _hoisted_12 = {
  class: "custom-title"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }, null, -1);
});
var _hoisted_14 = {
  key: 0,
  class: "van-field__error-message"
};
var _hoisted_15 = {
  key: 0,
  class: "sendCode"
};
var _hoisted_16 = {
  key: 1,
  class: "van-field__error-message activation-validCode"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "activation-divider"
  }, null, -1);
});
var _hoisted_18 = {
  class: "van-cascader__header"
};
var _hoisted_19 = {
  class: "van-cascader__title"
};
var _hoisted_20 = {
  class: "van-cascader__options"
};
var _hoisted_21 = ["onClick"];
var _hoisted_22 = {
  key: 0,
  class: "van-badge__wrapper van-icon van-icon-success van-cascader__selected-icon"
};
var _hoisted_23 = {
  class: "van-cascader__options"
};
var _hoisted_24 = ["onClick"];
var _hoisted_25 = {
  key: 0,
  class: "van-badge__wrapper van-icon van-icon-checked van-cascader__selected-icon"
};
var _hoisted_26 = {
  key: 0,
  style: {
    "padding": "16px",
    "box-sizing": "border-box"
  }
};
var _hoisted_27 = {
  class: "van-cascader__header van-cascader__title"
};
var _hoisted_28 = {
  class: "p16"
};
var _hoisted_29 = {
  class: "activation-footer"
};
var _hoisted_30 = {
  class: "activation-notice"
};
var _hoisted_31 = {
  class: "activation-notice-dialog"
};
var _hoisted_32 = {
  class: "ppHtml"
};
var _hoisted_33 = ["innerHTML"];
var _hoisted_34 = {
  class: "activation-notice-argree-dialog"
};
var _hoisted_35 = {
  class: "argree-title"
};
var _hoisted_36 = {
  class: "argree-cont"
};
var _hoisted_37 = ["innerHTML"];
var _hoisted_38 = ["innerHTML"];
var _hoisted_39 = {
  key: 0
};
import { computed, nextTick, onBeforeMount, onMounted, ref } from 'vue';
import { useDirectionalLang, getLang } from '@/hooks/directionalLang';
import { doLangFunction } from '@/hooks/lang';
import InfoApi from '@/api/info';
import XLCaptcha from '@shining3d/captacha';
import { useCountDown } from '@vant/use';
import { VueCookieNext } from 'vue-cookie-next';
import { useRoute } from 'vue-router';
import LoginApi from '@/api/pub';
import ProductApi from '@/api/product';
import { $rdoLang, $getCdnUrl, $isIos, $getCountry } from '@/assets/common/common.js';
import success from '@/views/activation-h5/success';
import { showToast } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/cascader/style';
import { useStore } from 'vuex';
import fastClick from 'fastclick';
import _get from 'lodash/get';
export default {
  setup: function setup(__props) {
    var $store = useStore();
    var route = useRoute();
    var routeQuery = route.query;
    var isOem = 'isOem' in routeQuery;
    if (isOem) {
      var $favicon = document.querySelector('link[rel="icon"]');
      if ($favicon) {
        $favicon.href = './default.ico';
      }
    }

    // zh-cn en-us ja-jp
    var curLang = doLangFunction((routeQuery === null || routeQuery === void 0 ? void 0 : routeQuery.lang) || 'zh-cn');
    var curLangKey = ref('en');
    if (curLang === 'zh-cn') {
      curLangKey.value = 'cn';
    } else if (curLang === 'ja-jp') {
      curLangKey.value = 'jap';
    }
    var uuid = VueCookieNext.getCookie('uuid');
    VueCookieNext.removeCookie('token');
    var isActivationSuccess = ref(false);
    var noticeArgeePopupShow = ref(false);
    var langkey = ref('zh_CN');
    var _useDirectionalLang = useDirectionalLang(langkey),
      $t = _useDirectionalLang.$t;
    var _useDirectionalLang2 = useDirectionalLang(langkey, '@shining3d/xl-login'),
      $tLogin = _useDirectionalLang2.$t;
    var apiToken = ref('');
    var getApiTokenFromNode = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getLang(curLang);
            case 2:
              langkey.value = _context.sent;
              ProductApi.getApiTokenFromNode().then(function (res) {
                if (res.status === 'success') {
                  apiToken.value = res.result;
                  getModelDetail();
                }
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getApiTokenFromNode() {
        return _ref.apply(this, arguments);
      };
    }();
    getApiTokenFromNode();
    var dlpImgUrl = ref(require('@/assets/image/dlp.svg'));
    // 获取对应型号的打印机图片
    var getModelDetail = function getModelDetail() {
      var _curLangKey$value;
      // lang: cn en ja
      ProductApi.getModelDetail({
        modelCode: routeQuery.modelCode,
        lang: (_curLangKey$value = curLangKey.value) === null || _curLangKey$value === void 0 ? void 0 : _curLangKey$value.slice(0, 2)
      }, {
        apiToken: apiToken.value
      }).then(function (res) {
        if (res.status === 'success') {
          var _res$result = res.result,
            bucket = _res$result.bucket,
            dfsID = _res$result.dfsID;
          if (bucket && dfsID) {
            var imgUrl = $getCdnUrl({
              bucket: bucket,
              dfsID: dfsID
            });
            if (!imgUrl.includes('undefined')) {
              dlpImgUrl.value = imgUrl;
            }
          }
        }
      });
    };

    // 隐私政策
    var noticePopupShow = ref(false);
    var handleShowNotice = function handleShowNotice(type) {
      noticePopupShow.value = true;
      getNoticeInfo(type, privacyHtml);
    };
    var getInfoLoading = ref(false);
    var privacyHtml = ref('');
    var termsofuseTextHtml = ref('');
    var policyHtml = ref('');
    var argreeActive = ref(0);
    var getNoticeInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var type,
          htmlTxt,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              type = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 'privacy';
              htmlTxt = _args2.length > 1 ? _args2[1] : undefined;
              getInfoLoading.value = true;
              _context2.next = 5;
              return LoginApi.getOigpc($rdoLang(curLang), 'index', type).then(function (res) {
                htmlTxt.value = res.result;
                getInfoLoading.value = false;
              }).catch(function () {
                getInfoLoading.value = false;
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getNoticeInfo() {
        return _ref2.apply(this, arguments);
      };
    }();
    var formRef = ref();
    var form = ref({
      country: '',
      countryValue: '',
      countryCode: '',
      phoneArea: '',
      contactMethod: '',
      validCode: '',
      userName: '',
      companyName: '',
      companyPurpose: [],
      // industry: '',
      industryText: '',
      companyType: '',
      companyTypeText: '',
      software: [],
      softwareText: '',
      productLine: 'dlp'
    });
    var isIndustryContainsDental = ref(false); // 行业是否选择齿科
    var noticeChecked = ref(false);
    var noticeArgeeCountTime = ref(3);
    var timer = null;
    var _startDisabled = function startDisabled() {
      startDisClear();
      timer = setTimeout(function () {
        noticeArgeeCountTime.value = noticeArgeeCountTime.value - 1;
        if (noticeArgeeCountTime.value > 0) {
          _startDisabled();
        }
      }, 1000);
    };
    var startDisClear = function startDisClear() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    };
    var getPValue = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(pValue, id, type) {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!id) {
                _context3.next = 5;
                break;
              }
              _context3.next = 3;
              return LoginApi.getOigpc($rdoLang(curLang), 'index', type, id);
            case 3:
              res = _context3.sent;
              pValue.value = _get(res, 'result') || '';
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function getPValue(_x, _x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    var privacyPolicyVersion = '';
    var usageClauseVersion = '';
    var origin = 'passport';
    var init = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res, clauseID, privacyID;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return LoginApi.getPrivacyView({
                oemURL: 'index',
                lang: $rdoLang(curLang),
                origin: origin
              });
            case 2:
              res = _context4.sent;
              clauseID = _get(res, 'result.clauseID');
              usageClauseVersion = _get(res, 'result.clauseVersion');
              privacyID = _get(res, 'result.privacyID');
              privacyPolicyVersion = _get(res, 'result.privacyVersion');
              _context4.next = 9;
              return getPValue(policyHtml, privacyID, 'privacy');
            case 9:
              _context4.next = 11;
              return getPValue(termsofuseTextHtml, clauseID, 'termsOfUse');
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function init() {
        return _ref4.apply(this, arguments);
      };
    }();
    var openPrivacyDiaRef = function openPrivacyDiaRef() {
      noticeArgeePopupShow.value = true;
      init().then(function () {
        noticeArgeeCountTime.value = 3;
        _startDisabled();
      });
    };
    var hasPrivacyDia = false;
    var noticeChange = function noticeChange(e) {
      if (e && !hasPrivacyDia) {
        openPrivacyDiaRef();
        nextTick(function () {
          noticePopupShow.value = false;
        });
      }
    };
    var argeeCheckBefore = false;
    var notNoticeArgeeBtn = function notNoticeArgeeBtn() {
      noticeArgeePopupShow.value = false;
      noticeChecked.value = false;
      argeeCheckBefore = false;
    };
    var noticeArgeeBtn = function noticeArgeeBtn() {
      hasPrivacyDia = true;
      noticeArgeePopupShow.value = false;
      noticeChecked.value = true;
      if (argeeCheckBefore) {
        onSubmit();
      }
    };

    // 未填数据时禁用下一步按钮
    var isSubmitBtnDisabled = computed(function () {
      var flag = true;
      var vals = Object.values(form.value);
      var hasValArr = vals.filter(function (item) {
        return item;
      });
      flag = hasValArr.length < vals.length - 2;
      return flag;
    });

    // 选择国家
    var showCountryPopup = ref(false);
    var searchCountryValue = ref('');
    var localAreaCodeOptions = ref(JSON.parse(localStorage.getItem('areaCodeOptions') || '[]'));
    var areaOptions = ref([]);
    var initCountry = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var cc, curCountry;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (JSON.parse(localStorage.getItem('areaCodeOptions') || '[]').length) {
                _context5.next = 4;
                break;
              }
              _context5.next = 3;
              return $getCountry();
            case 3:
              localAreaCodeOptions.value = $store.state.phoneAreaList;
            case 4:
              areaOptions.value = localAreaCodeOptions.value;
              cc = VueCookieNext.getCookie('cc') || 'CN';
              curCountry = areaOptions.value.find(function (val) {
                return val.value.includes("-".concat(cc));
              });
              handleSelectCountry(curCountry);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function initCountry() {
        return _ref5.apply(this, arguments);
      };
    }();
    var handleCountrySearch = function handleCountrySearch() {
      if (searchCountryValue.value) {
        areaOptions.value = localAreaCodeOptions.value.filter(function (item) {
          return item.label.toLowerCase().includes(searchCountryValue.value.toLowerCase());
        });
      } else {
        areaOptions.value = localAreaCodeOptions.value;
      }
    };
    var handleCountrySearchCancel = function handleCountrySearchCancel() {
      showCountryPopup.value = false;
      searchCountryValue.value = '';
      areaOptions.value = localAreaCodeOptions.value;
    };
    var handleSelectCountry = function handleSelectCountry(item) {
      form.value.country = item.label;
      form.value.countryValue = item.value;
      var arr = form.value.countryValue.split('-');
      form.value.phoneArea = arr[0];
      form.value.countryCode = arr[1];
      handleCountrySearchCancel();
    };

    // 阿里云验证码组件ref
    var captcharef = ref(null);
    // 阿里云验证码验证结果
    var aliVerifyResult = ref({});
    // 判断是否已发送过验证码
    var hasSendVerifyCode = false;
    // 重置验证码滑动组件
    var resetCaptcha = function resetCaptcha() {
      captcharef.value.resetCaptcha();
      aliVerifyResult.value = {};
      hasSendVerifyCode = false;
    };
    var authForm = ref({
      username: '',
      validCode: '',
      phoneArea: '',
      uuid: "passport-activation-".concat(VueCookieNext.getCookie('user_id')),
      captcha: '',
      source: 'activation',
      lang: curLang
    });
    var captchaTip = ref('');
    var validCodeTip = ref('');
    var formErr = ref();
    var countDown = useCountDown({
      time: 60 * 1000
    });
    var current = countDown.current;
    var curToken = ref('');
    var validateResult = ref({});
    var getToken = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return ProductApi.getToken({
                uuid: uuid
              }).then(function (res) {
                if (res.status === 'success') {
                  curToken.value = res.result;
                }
              });
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function getToken() {
        return _ref6.apply(this, arguments);
      };
    }();
    var validateBeforeGetCode = function validateBeforeGetCode() {
      formRef.value.validate('country');
      formRef.value.validate('contactMethod');
    };
    var toGetvCodeFirst = true;
    var getCode = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(value, callbacks) {
        var key;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              toGetvCodeFirst = false;
              validCodeTip.value = '';
              validateBeforeGetCode();
              countDown.reset();
              _context7.next = 6;
              return getToken();
            case 6:
              for (key in formErr.value) {
                formErr.value[key] = '';
              }
              form.value.validCode = '';
              authForm.value.validCode = '';
              // 当用户发送验证码成功后没有收到验证码需要重新获取时，需要重置验证码组件，如下,切记，当发送验证码成功后将hasSendVerifyCode设置为true
              if (hasSendVerifyCode === true) {
                // 若验证码曾成功发出过，再次点击获取则重置验证码滑动组件
                resetCaptcha();
              }
              captcharef.value.aliyunCaptchaVerifyState(function (state, res) {
                // 判断验证结果，state为true时会返回 验证参数
                if (state) {
                  captchaTip.value = '';
                  aliVerifyResult.value = res; // 该参数会在后续提交接口使用
                  // 将返回的验证码鉴权参数与服务端请求合理接口拼接
                  authForm.value = _objectSpread(_objectSpread(_objectSpread({}, authForm.value), {}, {
                    username: form.value.contactMethod,
                    phoneArea: form.value.countryValue.split('-')[0],
                    validCode: form.value.validCode
                  }, res), {}, {
                    captcha: curToken.value,
                    template: 'validCode.changeInfo' // 短信模板
                  });
                  validateResult.value = _objectSpread({}, res);
                  // 向接下来的请求的headers中添加x-auth-token  (已存入parameter)，若为登录后操作则不需要。
                  InfoApi.userValidate(authForm.value).then(function (resRol) {
                    if (resRol.status === 'success') {
                      console.log('验证码发送成功 ');
                      hasSendVerifyCode = true;
                      countDown.start();
                    } else {
                      resetCaptcha(); // 若获取验证码接口报错用户异常则直接重置验证码
                    }
                  }, function (error) {
                    console.log(error);
                  });
                } else if (res.validType) {
                  captchaTip.value = res.validType;
                }
              });
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function getCode(_x4, _x5) {
        return _ref7.apply(this, arguments);
      };
    }();
    var oldValidCodeInput = ref('');
    var validCodeRef = ref();
    // 解决ios验证码自动填充时重复填充两次
    var handleValidCodeUpdate = function handleValidCodeUpdate(val) {
      if (oldValidCodeInput.value.length >= 4 && val.length === oldValidCodeInput.value.length * 2) {
        var _validCodeRef$value;
        form.value.validCode = oldValidCodeInput.value;
        // eslint-disable-next-line no-unused-expressions
        (_validCodeRef$value = validCodeRef.value) === null || _validCodeRef$value === void 0 || _validCodeRef$value.blur();
      } else {
        oldValidCodeInput.value = val;
      }
    };

    // 行业应用
    var showIndustryPopup = ref(false);
    // 行业应用选项列表，children 代表子选项，支持多级嵌套
    var industryOptions = ref([]);
    var getIndustry = function getIndustry() {
      InfoApi.getIndustrySourceInfo('passport_industry_uses').then(function (res) {
        var industryArray = [];
        var defaultArray = [];
        Array.isArray(res.result) && res.result.forEach(function (pinfo) {
          if (pinfo.keyName === 'dlp') {
            industryArray = JSON.parse(pinfo.other);
          }
          if (pinfo.keyName === 'default') {
            defaultArray = JSON.parse(pinfo.other);
          }
        });
        if (industryArray.length <= 0) {
          industryArray = defaultArray;
        }
        industryOptions.value = industryArray;
        _convertDataFormat(industryOptions.value);
      });
    };
    getIndustry();
    var industryFirstSelectItem = ref({});
    var industryFirstSelectedIndex = ref(-1);
    var industrySecondSelectedIndexArr = ref([]);
    var industrySecondOptionArr = ref([]);
    var activeTabName = ref('a');
    var handleIndustrySelectChange = function handleIndustrySelectChange(item, index, level) {
      if (level === '0') {
        industryFirstSelectItem.value = item;
        industryFirstSelectedIndex.value = index;
        industrySecondSelectedIndexArr.value = [];
        nextTick(function () {
          var _industryOptions$valu;
          activeTabName.value = 'b';
          industrySecondOptionArr.value = (_industryOptions$valu = industryOptions.value[index]) === null || _industryOptions$valu === void 0 ? void 0 : _industryOptions$valu.children;
        });
      } else if (level === '1') {
        if (industrySecondSelectedIndexArr.value.includes(index)) {
          industrySecondSelectedIndexArr.value = industrySecondSelectedIndexArr.value.filter(function (i) {
            return i !== index;
          });
        } else {
          industrySecondSelectedIndexArr.value.push(index);
        }
      }
      setTimeout(function () {
        nextTick(function () {
          var _formRef$value, _formRef$value2;
          // 选择后把刚出现的选项移到页面中
          // eslint-disable-next-line no-unused-expressions
          (_formRef$value = formRef.value) === null || _formRef$value === void 0 || _formRef$value.scrollToField('companyType', false);
          // eslint-disable-next-line no-unused-expressions
          (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 || _formRef$value2.scrollToField('software', false);
        });
      }, 1000);
    };
    var handleIndustryFinish = function handleIndustryFinish(_ref8) {
      var value = _ref8.value,
        selectedOptions = _ref8.selectedOptions,
        tabIndex = _ref8.tabIndex;
      console.log('handleIndustryFinish', value, selectedOptions, tabIndex);
      showIndustryPopup.value = false;
      form.value.companyType = '';
      form.value.companyTypeText = '';
      form.value.software = [];
      form.value.softwareText = '';
      softwareActiveIds.value = [];
      form.value.companyPurpose = [];
      form.value.industryText = '';
      industrySecondSelectedIndexArr.value.sort();
      industrySecondSelectedIndexArr.value.forEach(function (i) {
        var tmpText = form.value.industryText;
        var tmpItem = industrySecondOptionArr.value[i];
        console.log(tmpText, tmpItem);
        form.value.industryText = tmpText === '' ? tmpItem.textChain : tmpText + '、' + tmpItem.textChain;
        form.value.companyPurpose.push(tmpItem.keyChain);
      });
      isIndustryContainsDental.value = industryFirstSelectItem.value.value === 'dentalscan';
      isIndustryContainsDental.value ? getOrgType() : getSoftwares();
    };

    // 组织类型
    var showCompanyTypePopup = ref(false);
    var companyTypeColumns = ref([]);
    // 获取组织类型列表
    var getOrgType = function getOrgType() {
      InfoApi.getIndustrySourceInfo('passport_dental_factory_type').then(function (res) {
        var orginArray = [];
        var defaultArray = [];
        Array.isArray(res.result) && res.result.forEach(function (pinfo) {
          if (pinfo.keyName === 'dentalscan' && pinfo.keyValue === 'default') {
            orginArray = JSON.parse(pinfo.other);
          }
          // 保存default下的数据，作为未配置时的兜底数据
          if (pinfo.keyName === 'default') {
            defaultArray = JSON.parse(pinfo.other);
          }
        });
        if (orginArray.length <= 0) {
          orginArray = defaultArray;
        }
        companyTypeColumns.value = orginArray;
        _convertDataFormat(companyTypeColumns.value);
      });
    };
    var handleCompanyTypeConfirm = function handleCompanyTypeConfirm(_ref9) {
      var selectedOptions = _ref9.selectedOptions;
      var selectObj = selectedOptions[0];
      form.value.companyTypeText = selectObj === null || selectObj === void 0 ? void 0 : selectObj.text;
      form.value.companyType = selectObj === null || selectObj === void 0 ? void 0 : selectObj.value;
      showCompanyTypePopup.value = false;
    };

    // 数据处理软件
    var showSoftwarePopup = ref(false);
    var softwareActiveIds = ref([]);
    var softwareActiveIndex = ref(0);
    var softwareItems = ref([]);
    var selectSoftwareItems = ref([]);
    var getSoftwares = function getSoftwares() {
      InfoApi.getIndustrySourceInfo('passport_product_soft').then(function (res) {
        var softwareArray = [];
        var defaultArray = [];
        res.result && res.result.forEach(function (pinfo) {
          if (pinfo.keyName === 'dlp') {
            softwareArray = JSON.parse(pinfo.other);
          }
          if (pinfo.keyName === 'default') {
            defaultArray = JSON.parse(pinfo.other);
          }
        });
        if (softwareArray.length <= 0) {
          softwareArray = defaultArray;
        }
        softwareItems.value = softwareArray;
        _convertDataFormat(softwareItems.value);
      });
    };
    var handleSoftwareClickItem = function handleSoftwareClickItem(item) {
      if (softwareActiveIds.value.includes(item.id)) {
        selectSoftwareItems.value.push(item.text);
        form.value.software.push(item.keyChain);
      } else {
        var index = selectSoftwareItems.value.findIndex(function (val) {
          return val === item.text;
        });
        selectSoftwareItems.value.splice(index, 1);
        var keyIndex = form.value.software.findIndex(function (val) {
          return val === item.keyChain;
        });
        form.value.software.splice(keyIndex, 1);
      }
    };
    var handleSoftwareConfirm = function handleSoftwareConfirm() {
      showSoftwarePopup.value = false;
      form.value.softwareText = selectSoftwareItems.value.join('、');
    };

    // 转换数据格式适配弹框组件
    var _convertDataFormat = function convertDataFormat(arr) {
      var keyChain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var textChain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      arr.forEach(function (val) {
        var _val$childs;
        val.textObj = val.text;
        val.id = val.value;
        val.text = val.textObj[curLangKey.value] || val.textObj.en;
        val.keyChain = keyChain ? keyChain + '/' + val.value : val.value;
        val.textChain = textChain ? textChain + '/' + val.text : val.text;
        if (val !== null && val !== void 0 && (_val$childs = val.childs) !== null && _val$childs !== void 0 && _val$childs.length) {
          _convertDataFormat(val.childs, val.keyChain, val.textChain);
          val.children = val.childs;
        }
      });
    };
    var onSubmitBefore = function onSubmitBefore() {
      if (toGetvCodeFirst) {
        validCodeTip.value = $tLogin('apiError.toGetvCodeFirst');
      } else if (noticeChecked.value) {
        onSubmit();
      } else {
        argeeCheckBefore = true;
        openPrivacyDiaRef();
      }
    };
    var submitLoading = ref(false);
    var onSubmit = function onSubmit() {
      submitLoading.value = true;
      ProductApi.applyH5(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, validateResult.value), form.value), routeQuery), {}, {
        captcha: authForm.value.captcha,
        uuid: authForm.value.uuid,
        privacyPolicyVersion: privacyPolicyVersion,
        usageClauseVersion: usageClauseVersion,
        origin: origin,
        privacy: noticeChecked.value
      }), {
        apiToken: apiToken.value
      }).then(function (res) {
        submitLoading.value = false;
        if (res.status === 'success') {
          isActivationSuccess.value = true;
        } else if (res.result && res.result.includes('hasSlidingValidCode')) {
          validCodeTip.value = $t('apiErr.info.bindSilde.validCodehasSlidingValidCode');
        } else {
          showToast({
            message: $t('activation.h5.activateErr'),
            icon: require('@/assets/image/error.svg')
          });
        }
      }, function () {
        submitLoading.value = false;
      });
    };
    var onFailed = function onFailed(errorInfo) {
      console.log('failed', errorInfo);
    };

    // 解决输入数据时底部按钮会弹起到键盘上方显示， 
    // 1、 安卓键盘弹起会触发页面的resize 事件（ios不会），所以可以通过判断页面高度的前后变化来判断键盘的状态。
    // 2、 ios 在键盘收起的时候input 会失去焦点（安卓不会），所以可以通过input 的focus 和 blur 事件来判断键盘的状态
    var showFooter = ref(true);
    var originHeight = ref(document.documentElement.clientHeight || document.body.clientHeight);
    var activationRef = ref(null);
    var setBodyHeight = function setBodyHeight() {
      var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (activationRef.value) {
        activationRef.value.style.height = resizeHeight + 'px';
      }
      document.querySelector('#app').style.height = resizeHeight + 'px';
    };
    var handleResize = function handleResize() {
      var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
      if (!$isIos()) {
        showFooter.value = !(resizeHeight < originHeight.value); // true安卓---显示底部栏 false安卓---隐藏底部栏
      }
      setBodyHeight();
    };
    var handleFocus = function handleFocus() {
      validCodeTip.value = '';
      if ($isIos()) {
        showFooter.value = false; // 'ios---隐藏底部栏'
      }
    };
    var handleBlur = function handleBlur() {
      if ($isIos()) {
        showFooter.value = true; // 'ios---显示底部栏'
      }
    };
    onBeforeMount(function () {
      // 解决ios软键盘弹起时，点击popup弹框不会弹出问题，原因：移动端点击事件有300 ms延迟
      fastClick.attach(document.body);
      fastClick.prototype.focus = function (ele) {
        'use strict';

        ele.focus();
      }; // 修改focus()方法
    });
    onMounted(function () {
      setBodyHeight();
      initCountry();
      window.addEventListener('resize', handleResize);
    });
    onBeforeUnmount(function () {
      window.removeEventListener('resize', handleResize);
    });
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_search = _resolveComponent("van-search");
      var _component_van_cell = _resolveComponent("van-cell");
      var _component_van_popup = _resolveComponent("van-popup");
      var _component_van_notice_bar = _resolveComponent("van-notice-bar");
      var _component_van_tab = _resolveComponent("van-tab");
      var _component_van_tabs = _resolveComponent("van-tabs");
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_picker = _resolveComponent("van-picker");
      var _component_van_tree_select = _resolveComponent("van-tree-select");
      var _component_van_checkbox = _resolveComponent("van-checkbox");
      var _component_van_form = _resolveComponent("van-form");
      var _component_van_config_provider = _resolveComponent("van-config-provider");
      var _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [!isActivationSuccess.value ? (_openBlock(), _createBlock(_component_van_config_provider, {
        key: 0
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_form, {
            ref_key: "formRef",
            ref: formRef,
            onSubmit: onSubmitBefore,
            onFailed: onFailed
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                class: "activation",
                ref_key: "activationRef",
                ref: activationRef
              }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
                class: _normalizeClass(["activation-header", {
                  'isOem': isOem
                }])
              }, [!isOem ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
                class: "activation-header-product-img",
                src: dlpImgUrl.value,
                alt: ""
              }, null, 8, _hoisted_6), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("span", null, [_hoisted_7, _createTextVNode(" " + _toDisplayString(_unref($t)('activation.h5.modelCode')), 1)]), _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(routeQuery).modelCode), 1)]), _createElementVNode("li", null, [_createElementVNode("span", null, [_hoisted_9, _createTextVNode(" " + _toDisplayString(_unref($t)('activation.h5.sn')), 1)]), _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(routeQuery).sn), 1)])])])], 2), _createVNode(_component_van_field, {
                modelValue: form.value.country,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return form.value.country = $event;
                }),
                required: "",
                "is-link": "",
                name: "country",
                label: _unref($t)('activation.h5.country'),
                placeholder: _unref($t)('activation.h5.countryPlaceholder'),
                "label-align": "top",
                rules: [{
                  required: true,
                  message: _unref($t)('activation.h5.countryPlaceholder')
                }],
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return showCountryPopup.value = true;
                })
              }, null, 8, ["modelValue", "label", "placeholder", "rules"]), _createVNode(_component_van_popup, {
                show: showCountryPopup.value,
                "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
                  return showCountryPopup.value = $event;
                }),
                position: "right"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_11, [_createVNode(_component_van_search, {
                    modelValue: searchCountryValue.value,
                    "onUpdate:modelValue": [_cache[2] || (_cache[2] = function ($event) {
                      return searchCountryValue.value = $event;
                    }), handleCountrySearch],
                    placeholder: _unref($t)('activation.h5.search'),
                    "show-action": ""
                  }, {
                    action: _withCtx(function () {
                      return [_createElementVNode("div", {
                        onClick: handleCountrySearchCancel
                      }, _toDisplayString(_unref($t)('button.cancel')), 1)];
                    }),
                    _: 1
                  }, 8, ["modelValue", "placeholder"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaOptions.value, function (item) {
                    return _openBlock(), _createBlock(_component_van_cell, {
                      key: item.value,
                      onClick: function onClick($event) {
                        return handleSelectCountry(item);
                      }
                    }, _createSlots({
                      title: _withCtx(function () {
                        return [_createElementVNode("span", _hoisted_12, _toDisplayString(item.label), 1)];
                      }),
                      _: 2
                    }, [form.value.countryValue === item.value ? {
                      name: "right-icon",
                      fn: _withCtx(function () {
                        return [_hoisted_13];
                      })
                    } : undefined]), 1032, ["onClick"]);
                  }), 128))])];
                }),
                _: 1
              }, 8, ["show"]), _createVNode(_component_van_field, {
                modelValue: form.value.contactMethod,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                  return form.value.contactMethod = $event;
                }),
                required: "",
                name: "contactMethod",
                label: _unref($t)('activation.h5.contactMethod'),
                placeholder: _unref($t)('activation.h5.contactMethodPlaceholder'),
                "label-align": "top",
                onFocus: handleFocus,
                onBlur: handleBlur,
                rules: [{
                  required: true,
                  message: _unref($t)('activation.h5.contactMethodPlaceholder')
                }]
              }, null, 8, ["modelValue", "label", "placeholder", "rules"]), !isOem ? (_openBlock(), _createBlock(_component_van_notice_bar, {
                key: 0,
                color: "#5587ff",
                background: "#EDF3FF",
                "left-icon": "info"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref($t)('activation.h5.contactMethodTip')), 1)];
                }),
                _: 1
              })) : _createCommentVNode("", true), _createElementVNode("div", {
                class: _normalizeClass(["activation-captcha", noticePopupShow.value ? 'activation-captcha-hide' : ''])
              }, [_createVNode(_unref(XLCaptcha), {
                ref_key: "captcharef",
                ref: captcharef,
                scene: "register",
                "product-key": "dentalcloud",
                customLang: _unref(curLang)
              }, null, 8, ["customLang"]), captchaTip.value ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(captchaTip.value), 1)) : _createCommentVNode("", true)], 2), _createVNode(_component_van_field, {
                modelValue: form.value.validCode,
                "onUpdate:modelValue": [_cache[5] || (_cache[5] = function ($event) {
                  return form.value.validCode = $event;
                }), handleValidCodeUpdate],
                center: "",
                required: "",
                ref_key: "validCodeRef",
                ref: validCodeRef,
                name: "validCode",
                label: _unref($t)('activation.h5.validCode'),
                "label-align": "top",
                onFocus: handleFocus,
                onBlur: handleBlur,
                placeholder: _unref($t)('activation.h5.validCodePlaceholder'),
                rules: [{
                  required: true,
                  message: _unref($t)('activation.h5.validCodePlaceholder')
                }]
              }, {
                button: _withCtx(function () {
                  return [_unref(current).seconds > 0 && _unref(current).seconds < 60 ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(current).seconds) + "s", 1)) : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "sendCode",
                    onClick: getCode
                  }, _toDisplayString(_unref($t)('activation.h5.sendValidCode')), 1))];
                }),
                _: 1
              }, 8, ["modelValue", "label", "placeholder", "rules"]), validCodeTip.value ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(validCodeTip.value), 1)) : _createCommentVNode("", true), _hoisted_17, _createVNode(_component_van_field, {
                modelValue: form.value.userName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                  return form.value.userName = $event;
                }),
                required: "",
                name: "userName",
                label: _unref($t)('activation.h5.userName'),
                placeholder: _unref($t)('activation.h5.userNamePlaceholder'),
                "label-align": "top",
                onFocus: handleFocus,
                onBlur: handleBlur,
                rules: [{
                  required: true,
                  message: _unref($t)('activation.h5.userNamePlaceholder')
                }]
              }, null, 8, ["modelValue", "label", "placeholder", "rules"]), _createVNode(_component_van_field, {
                modelValue: form.value.companyName,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                  return form.value.companyName = $event;
                }),
                required: "",
                name: "companyName",
                label: _unref($t)('activation.h5.companyName'),
                placeholder: _unref($t)('activation.h5.companyNamePlaceholder'),
                "label-align": "top",
                onFocus: handleFocus,
                onBlur: handleBlur,
                rules: [{
                  required: true,
                  message: _unref($t)('activation.h5.companyNamePlaceholder')
                }]
              }, null, 8, ["modelValue", "label", "placeholder", "rules"]), _createVNode(_component_van_field, {
                modelValue: form.value.industryText,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
                  return form.value.industryText = $event;
                }),
                "is-link": "",
                required: "",
                readonly: "",
                "label-align": "top",
                label: _unref($t)('activation.h5.industryText'),
                name: "industry",
                placeholder: _unref($t)('activation.h5.industryTextPlaceholder'),
                rules: [{
                  required: true,
                  message: _unref($t)('activation.h5.industryTextPlaceholder')
                }],
                onClick: _cache[9] || (_cache[9] = function ($event) {
                  return showIndustryPopup.value = true;
                })
              }, null, 8, ["modelValue", "label", "placeholder", "rules"]), _createVNode(_component_van_popup, {
                show: showIndustryPopup.value,
                "onUpdate:show": _cache[11] || (_cache[11] = function ($event) {
                  return showIndustryPopup.value = $event;
                }),
                round: "",
                position: "bottom",
                closeable: ""
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_18, [_createElementVNode("h2", _hoisted_19, _toDisplayString(_unref($t)('activation.h5.industryTextPlaceholder')), 1)]), _createVNode(_component_van_tabs, {
                    active: activeTabName.value,
                    "onUpdate:active": _cache[10] || (_cache[10] = function ($event) {
                      return activeTabName.value = $event;
                    }),
                    animated: "",
                    shrink: ""
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_van_tab, {
                        title: industryFirstSelectItem.value.text || _unref($t)('common.selectPlaceholder'),
                        name: "a"
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("ul", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryOptions.value, function (item, index) {
                            return _openBlock(), _createElementBlock("li", {
                              key: index,
                              class: _normalizeClass(["van-cascader__option", industryFirstSelectedIndex.value === index ? 'van-cascader__option--selected' : '']),
                              onClick: function onClick($event) {
                                return handleIndustrySelectChange(item, index, '0');
                              }
                            }, [_createElementVNode("span", null, _toDisplayString(item.text), 1), industryFirstSelectedIndex.value === index ? (_openBlock(), _createElementBlock("i", _hoisted_22)) : _createCommentVNode("", true)], 10, _hoisted_21);
                          }), 128))])];
                        }),
                        _: 1
                      }, 8, ["title"]), industryFirstSelectedIndex.value !== -1 ? (_openBlock(), _createBlock(_component_van_tab, {
                        key: 0,
                        title: _unref($t)('common.selectPlaceholder'),
                        name: "b"
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("ul", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industrySecondOptionArr.value, function (item, index) {
                            return _openBlock(), _createElementBlock("li", {
                              key: item.value + index,
                              class: _normalizeClass(["van-cascader__option", industrySecondSelectedIndexArr.value.includes(index) ? 'van-cascader__option--selected' : '']),
                              onClick: function onClick($event) {
                                return handleIndustrySelectChange(item, index, '1');
                              }
                            }, [_createElementVNode("span", null, _toDisplayString(item.text), 1), industrySecondSelectedIndexArr.value.includes(index) ? (_openBlock(), _createElementBlock("i", _hoisted_25)) : _createCommentVNode("", true)], 10, _hoisted_24);
                          }), 128))])];
                        }),
                        _: 1
                      }, 8, ["title"])) : _createCommentVNode("", true)];
                    }),
                    _: 1
                  }, 8, ["active"]), activeTabName.value === 'b' ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_van_button, {
                    round: "",
                    type: "primary",
                    block: "",
                    size: "medium",
                    onClick: handleIndustryFinish
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref($t)('button.determine')), 1)];
                    }),
                    _: 1
                  })])) : _createCommentVNode("", true)];
                }),
                _: 1
              }, 8, ["show"]), _withDirectives(_createVNode(_component_van_field, {
                modelValue: form.value.companyTypeText,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
                  return form.value.companyTypeText = $event;
                }),
                "is-link": "",
                readonly: "",
                required: "",
                name: "companyType",
                label: _unref($t)('activation.h5.companyType'),
                placeholder: _unref($t)('activation.h5.companyTypePlaceholder'),
                "label-align": "top",
                onClick: _cache[13] || (_cache[13] = function ($event) {
                  return showCompanyTypePopup.value = true;
                })
              }, null, 8, ["modelValue", "label", "placeholder"]), [[_vShow, form.value.industryText && isIndustryContainsDental.value]]), _createVNode(_component_van_popup, {
                show: showCompanyTypePopup.value,
                "onUpdate:show": _cache[15] || (_cache[15] = function ($event) {
                  return showCompanyTypePopup.value = $event;
                }),
                round: "",
                position: "bottom"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_van_picker, {
                    title: _unref($t)('activation.h5.companyType'),
                    columns: companyTypeColumns.value,
                    "confirm-button-text": _unref($t)('button.determine'),
                    "cancel-button-text": _unref($t)('button.cancel'),
                    onConfirm: handleCompanyTypeConfirm,
                    onCancel: _cache[14] || (_cache[14] = function ($event) {
                      return showCompanyTypePopup.value = false;
                    })
                  }, null, 8, ["title", "columns", "confirm-button-text", "cancel-button-text"])];
                }),
                _: 1
              }, 8, ["show"]), _withDirectives(_createVNode(_component_van_field, {
                modelValue: form.value.softwareText,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
                  return form.value.softwareText = $event;
                }),
                "is-link": "",
                readonly: "",
                required: "",
                name: "software",
                label: _unref($t)('activation.h5.softwareText'),
                placeholder: _unref($t)('activation.h5.softwareTextPlaceholder'),
                "label-align": "top",
                onClick: _cache[17] || (_cache[17] = function ($event) {
                  return showSoftwarePopup.value = true;
                })
              }, null, 8, ["modelValue", "label", "placeholder"]), [[_vShow, form.value.industryText && !isIndustryContainsDental.value]]), _createVNode(_component_van_popup, {
                show: showSoftwarePopup.value,
                "onUpdate:show": _cache[20] || (_cache[20] = function ($event) {
                  return showSoftwarePopup.value = $event;
                }),
                closeable: "",
                round: "",
                position: "bottom"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_27, _toDisplayString(_unref($t)('activation.h5.softwareTextPlaceholder')), 1), _createVNode(_component_van_tree_select, {
                    "active-id": softwareActiveIds.value,
                    "onUpdate:active-id": _cache[18] || (_cache[18] = function ($event) {
                      return softwareActiveIds.value = $event;
                    }),
                    "main-active-index": softwareActiveIndex.value,
                    "onUpdate:main-active-index": _cache[19] || (_cache[19] = function ($event) {
                      return softwareActiveIndex.value = $event;
                    }),
                    items: softwareItems.value,
                    title: _unref($t)('activation.h5.softwareTextPlaceholder'),
                    onClickItem: handleSoftwareClickItem
                  }, null, 8, ["active-id", "main-active-index", "items", "title"]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_van_button, {
                    round: "",
                    block: "",
                    type: "primary",
                    onClick: handleSoftwareConfirm
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref($t)('button.determine')), 1)];
                    }),
                    _: 1
                  })])];
                }),
                _: 1
              }, 8, ["show"])]), _withDirectives(_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_van_checkbox, {
                modelValue: noticeChecked.value,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) {
                  return noticeChecked.value = $event;
                }),
                "label-disabled": "",
                onChange: noticeChange
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref($t)('activation.h5.noticeChecked')) + " ", 1), _createElementVNode("span", {
                    onClick: _cache[21] || (_cache[21] = function ($event) {
                      return handleShowNotice('privacy');
                    })
                  }, "《" + _toDisplayString(_unref($t)('activation.h5.policy')) + "》", 1), _createElementVNode("span", {
                    onClick: _cache[22] || (_cache[22] = function ($event) {
                      return handleShowNotice('termsOfUse');
                    })
                  }, "《" + _toDisplayString(_unref($t)('home.termsofuseText')) + "》", 1)];
                }),
                _: 1
              }, 8, ["modelValue"])]), _createVNode(_component_van_popup, {
                show: noticePopupShow.value,
                "onUpdate:show": _cache[25] || (_cache[25] = function ($event) {
                  return noticePopupShow.value = $event;
                }),
                "close-on-click-overlay": false,
                round: ""
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_31, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", {
                    class: "ppHtml-content",
                    innerHTML: privacyHtml.value
                  }, null, 8, _hoisted_33)])), [[_directive_loading, getInfoLoading.value]]), _createVNode(_component_van_button, {
                    plain: "",
                    type: "primary",
                    block: "",
                    size: "large",
                    onClick: _cache[24] || (_cache[24] = function ($event) {
                      return noticePopupShow.value = false;
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref($t)('button.close')), 1)];
                    }),
                    _: 1
                  })])];
                }),
                _: 1
              }, 8, ["show"]), _createVNode(_component_van_button, {
                round: "",
                block: "",
                type: "primary",
                "native-type": "submit",
                loading: submitLoading.value,
                disabled: _unref(isSubmitBtnDisabled)
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref($t)('activation.h5.activateNow')), 1)];
                }),
                _: 1
              }, 8, ["loading", "disabled"])], 512), [[_vShow, showFooter.value]])], 512)];
            }),
            _: 1
          }, 512)];
        }),
        _: 1
      })) : (_openBlock(), _createBlock(_unref(success), {
        key: 1,
        sn: _unref(routeQuery).sn,
        modelCode: _unref(routeQuery).modelCode,
        dlpImgUrl: dlpImgUrl.value,
        langkey: langkey.value,
        isOem: isOem
      }, null, 8, ["sn", "modelCode", "dlpImgUrl", "langkey"])), _createVNode(_component_van_popup, {
        show: noticeArgeePopupShow.value,
        "onUpdate:show": _cache[27] || (_cache[27] = function ($event) {
          return noticeArgeePopupShow.value = $event;
        }),
        "close-on-click-overlay": false,
        round: ""
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(_unref($tLogin)('privacyTermsOfUse.title')), 1), _createElementVNode("div", _hoisted_36, [_createVNode(_component_van_tabs, {
            modelValue: argreeActive.value,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = function ($event) {
              return argreeActive.value = $event;
            })
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_tab, {
                title: _unref($t)('activation.h5.policy')
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "ppHtml-content",
                    innerHTML: policyHtml.value
                  }, null, 8, _hoisted_37)];
                }),
                _: 1
              }, 8, ["title"]), _createVNode(_component_van_tab, {
                title: _unref($t)('home.termsofuseText')
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    class: "ppHtml-content",
                    innerHTML: termsofuseTextHtml.value
                  }, null, 8, _hoisted_38)];
                }),
                _: 1
              }, 8, ["title"])];
            }),
            _: 1
          }, 8, ["modelValue"])]), _createVNode(_component_van_button, {
            round: "",
            type: "primary",
            style: {
              "width": "236px",
              "margin-bottom": "8px"
            },
            loading: submitLoading.value,
            disabled: noticeArgeeCountTime.value > 0,
            block: "",
            onClick: noticeArgeeBtn
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref($tLogin)('privacyTermsOfUse.agreeAndContinue')) + " ", 1), noticeArgeeCountTime.value > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_39, "(" + _toDisplayString(noticeArgeeCountTime.value) + "s)", 1)) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["loading", "disabled"]), _createVNode(_component_van_button, {
            round: "",
            text: "",
            style: {
              "width": "236px",
              "margin-bottom": "8px"
            },
            block: "",
            onClick: notNoticeArgeeBtn
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref($tLogin)('privacyTermsOfUse.disagree')), 1)];
            }),
            _: 1
          })])];
        }),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};